declare var $: any;

export class ReferenceHousesComponent {
    static init() {
        $(".js-reference-house-carousel").on("slid.bs.carousel",
            (e: any) => {
                $(".js-reference-house-radio", $(e.relatedTarget)).prop("checked", true).trigger("change");
            });

        const $selectedRadio = $(".js-reference-house-radio:checked");
        if ($selectedRadio.length > 0) {
            ReferenceHousesComponent.slideToSelected($selectedRadio);
        } else {
            ReferenceHousesComponent.selectVisible();
        }
        $(".js-supplier-contact h4").on("click", ReferenceHousesComponent.toggleContactInfo);
    }

    static slideToSelected($selectedRadio: any) {
        const $carousel = $selectedRadio.parents(".js-reference-house-carousel");
        const $selectedSlide = $selectedRadio.parents(".item");
        const $selectedSlideIndex = $(".item", $carousel).index($selectedSlide);
        $carousel.removeClass("slide");
        $carousel.carousel($selectedSlideIndex);
        $carousel.addClass("slide");
    }

    static selectVisible() {
        $(".js-reference-house-radio", $(".js-reference-house-carousel:visible .active")).prop("checked", true).trigger("change");
    }

    static toggleContactInfo(e: Event) {
        var $h4 = $(e.target);
        var $body = $h4.next(".supplier-contact-body");
        if ($body.is(":visible"))
            $body.hide(150);
        else
            $body.show(200);

        $h4.closest("li").toggleClass("open");
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/referenceHousesComponent.ts